export default {
  enum: {
    position: 'Position (supplier)',
    purchaser: 'Purchaser (contractor)',
    dictionaryValue: 'Dictionary value',
    brand: 'Brand',
    permission: 'Permission (access)',

    projects: 'Projects',
    campaigns: 'Campaigns',

    pl: 'Polish',
    en: 'English',

    standard: 'Standard',
    commission: 'Commission',
    transferredCommission: 'Transferred commission',
    technicalCost: 'Technical cost',

    new: 'New',
    completed: 'Completed',
    accepted: 'Accepted',
    rejected: 'Rejected',

    notSent: 'Not sent',
    sent: 'Sent',
    error: 'Error',
    ok: 'OK',
    duplicate: 'Duplicate',

    acceptedByClient: 'Accepted by purchaser',
    readyForInvoice: 'Ready for invoicing',
    invoiced: 'Invoiced',
    corrected: 'Corrected',
    settled: 'Settled',
    cancelled: 'Cancelled',
    withdrawn: 'Withdrawn',

    foreign: 'Foreign',
    domestic: 'Domestic',

    draft: 'Draft',
    generated: 'Approved',
    sentShe: 'Sent',
    paid: 'Paid',
    inKSeF: 'In KSeF',

    open: 'Entered',
    approved: 'Approved',

    bankTransfer: 'Bank transfer',
    compensation: 'Compensation',
    prepayment: 'Prepayment',
    paidIt: 'Paid',

    newPlural: 'New',
    acceptedPlural: 'Accepted',
    rejectedPlural: 'Rejected',
    toBeCorrected: 'Requires correction',

    budget: 'With budget',
    project: 'With project',
    purchaseInvoice: 'With sales invoice',
    estimateItemCommentMediaplanner:
      'With media planner comment for project position',
    estimateItemCommentFinance: 'With finance comment for project position',
    estimateByMonthMediaplanner:
      'With media planner comment for project profile',
    estimateByMonthFinance: 'With finance comment for project profile',
    contract: 'With contract',
    signedContract: 'With signed contract',
    employeeSign: 'With employee signature',
    salesInvoice: 'With sales invoice (email attachment)',
    sentEmail: 'With sent email',

    statusReversal: 'Status reversal',
    automaticOperation: 'Automatic operation',
    automaticallyApproved: 'Invoice was automatically approved',
    revertFromApproved: 'Invoice was reverted from Approved',
    revertFromSent: 'Invoice was reverted from Sent',

    sales: 'Sales',
    purchase: 'Purchase',

    projectNoun: 'Project/campaign',
    purchaseInvoiceNoun: 'Purchase invoice',
    saleInvoiceNoun: 'Sales invoice',
    specialInvoicingNoun: 'Custom invoicing',

    delayed: 'Delayed',
    toCancel: 'To cancel',
    dateChange: 'Period change',
    all: 'All',

    others: 'Standard',
    tvBuying: 'TV Purchase',
    MPC: 'MPC',

    paymentStatusPaid: 'Paid',
    paymentStatusPartiallyPaid: 'Partially paid',
    paymentStatusPending: 'Awaiting payment',
    paymentStatusOverdue: 'Overdue',
    paymentStatusOverduePartiallyPaid: 'Overdue, partially paid',

    applications: 'Request',
    positionAppForeign: 'Foreign position request',
    applicationExecutions: 'Request execution',
    orders: 'Order',
    ordersRemind: 'Order - reminder',
    orderExecutions: 'Order execution',
    orderExecutionsRemind: 'Order execution - reminder',
    unblockEstimateByMonth: 'Request to unblock sales/purchases',
    projectsDelayed: 'Creating project/campaign after the permissible period',
    projectsToCancel: 'Canceling project/campaign',
    purchaseDeficiencies: 'Clarifying purchasing deficiencies',
    specialInvoicing: 'Special invoicing',
    salesInvoicing: 'Sales - invoicing',
    noPurchaserInOrder: 'No purchaser in order',
    purchaserCreatedInOrder: 'Automatic purchaser creation',
    purchaserEditedInOrder: 'Automatic purchaser edit',
    tooManyPurchasersInOrder: 'Too many purchasers in order',
    contractImportError: 'Contract import errors',
    contractsWaitingToSign: 'Contracts waiting to be signed',
    projectDateChange: 'Project/campaign date change',
    cyclicJobError: 'Cyclic job error',
    mirrorProject: 'Automatic creation of re-invoicing campaign',

    salesInvoiceToContractor: 'Sales invoice to contractor',
    salesInvoiceDuplicateToContractor: 'Sales invoice duplicate to contractor',
    surveyToClient: 'Survey to client',
    excelImport: 'Excel import',
    signedContracts: 'Signed contracts',
    fvzTeamReminder: 'Purchase invoice reminder for team',
    mirrorProjectError: 'Re-invoicing campaign creation error',

    orderExecutionReminder: 'Order execution - reminder',
    orderReminder: 'Order - reminder',
    dailyFVZReminder: 'Purchase invoicing - daily reminder',
    weekFVZReminder: 'Purchase invoicing - weekly reminder',
    externalContractsImport: 'External contracts - import',
    deleteBlockadeMonthException:
      'Automatic delete the exception of the blockade month',
    waitingContractsToSign: 'Waiting for contracts to be signed',
    reportEstimateItemsDataRawToGoogleDrive:
      'Report estimate items data raw to Google Drive',
    eodClients: 'EOD - clients data export',
    eodDocuments: 'EOD - purchase invoices import / export and posting',
    importKSeFFromSymphonyHandel: 'Import KSeF from Symphony Handel',
    exportSalesInvoicesToSymphony: 'Export sales invoices to Symphony Handel',
    generateSurveyForClients: 'Surveys - prepare for clients',
    sendSurveyToClients: 'Surveys - send to clients',
    backupSurowkaToGoogleDrive: 'Raw data - backup to Google Drive',
    refreshSalesInvoicePayments: 'Sales invoice payments - refresh data',
    syncFromOneTool: 'OneTool - sync teams and employees',

    poland: 'Poland',
    unitedStates: 'United States',
    germany: 'Germany',

    entered: 'Entered',
    waitingForSigning: 'Waiting for signing',
    signed: 'Signed',
    unsigned: 'Unsigned',

    dateOfIssue: 'According to the date of issue',
    dateOfSale: 'According to the date of sale',
    dateOfProject: 'According to the date of mediaplan',

    campaignCompletion: 'Campaign completion',
    contracts: 'Contracts',
    intercompanyOrders: 'Intercompany orders',
    campaignSettlement: 'Campaign settlement',
    notStarted: 'Not started',
    inProgress: 'Pending',
    notApplicable: 'Not applicable',

    nextMonthEnd: 'Next month end',
    currentMonthEnd: 'Current month end',
    lastMonthEnd: 'Last month end',
    fifteenthOfCurrentMonth: 'Fifteenth of current month',
    fifteenthOfNextMonth: 'Fifteenth of next month',
    sinceProjectCreation: 'Since project creation',

    high: 'High',
    medium: 'Medium',
    low: 'Low',

    scopeGlobal: 'Global',
    scopeCompany: 'Company',
    scopePurchaser: 'Purchaser',

    onceAYear: 'Once a year',
    semiAnnually: 'Semi-annually',
    quarterly: 'Quarterly',
    monthly: 'Monthly',

    allShe: 'All',
    purchaserShort: 'Purchasers',
    supplier: 'Suppliers',
    clientsGroup: 'Client groups',

    text: 'Text',
    yesNo: 'Yes/No',
    yesNoText: 'Yes/No + Text',

    yes: 'Yes',
    no: 'No',
    // Timeline steps translations
    atLeastOneProfilePerMonth: 'At least one profile per month',
    noMediaplanForMediaProfileInCurrentMonth:
      'No mediaplan for media profile in current month',
    atLeastOneItemAdded: 'At least one item added',
    specialInvoicingRequest: 'Mediaplan approved by client',
    customBillingRequest: 'Custom billing request',
    allItemsWithAmountsEnteredForCurrentMonth:
      'All items with amounts entered for current month',
    projectCancelledRequest: 'Project/campaign cancellation request',
    projectDateChangeRequest: 'Project/campaign date change request',
    requiredCampaignDocumentsAdded: 'Required project/campaign documents added',
    checkContractsCoverage: 'Positions covered by contracts',
    contractsSignedByResponsiblePerson:
      'Contracts signed by responsible person',
    noContract: 'No contracts',
    contractSent: 'Contract sent',
    orderCreatedForDeliveryTeam: 'Order created for delivery team',
    orderApprovedByDeliveryTeam: 'Intercompany order approved by delivery team',
    orderExecutionCreated: 'Order execution created',
    orderExecutionApproved: 'Order execution approved',
    orderExecutionPositionsSumValidation:
      'Order execution positions sum not equal to order positions sum',
    monthlySettlementReminder: 'Monthly settlement reminder',
    currentMonthReadyForInvoicing: 'Current month ready for invoicing',
    statusConfirmedByDocuments: 'Status confirmed by documents',
    salesSettlementCompleted: 'Sales settlement completed',
    pendingFVZAssignedToCampaign: 'Pending FVZ assigned to project/campaign',
    missingFVZ: 'Missing FVZ',
    purchaseSettlementCompleted: 'Purchase settlement completed',
    campaignsWithBlockingInvoicingErrors:
      'Projects/campaigns with blocking invoicing errors',
    salesInvoiceSent: 'Sales invoice sent',
    mediaplanCorrection: 'Mediaplan correction',
    timelineError: 'Actions required',
  },
  param: {
    lastProcessedDocumentsDate: 'Last processed documents date',
    lastProcessedClientsDate: 'Last processed clients date',
    turnOffPurchaseInvoiceDomestic:
      'Turn off adding domestic purchase invoices',
    daysToCancelFVZNumber:
      'Number of days from FVZ creation to FVZ cancellation',
    umpRequestUserForDebug: 'DEBUG: User for UMP debugging',
    umpLogs: 'DEBUG: Turn on UMP logs',
    eod: 'EOD',
    fvz: 'FVZ',
    ump: 'UMP',
    newPositionApplicationUrl: 'URL to new position application',
    surowkaFromYear: 'Raw data - start year for report generation',
    surowkaBaseName: 'Raw data - base file name (without year and extension)',
    surowkaBackupSubfolder: 'Raw data - backup subfolder name on Google Drive',
    surowka: 'Raw data',
    system: 'System',
    api: 'API',
    mirrorProjectResponsibleUser: 'User responsible for re-invoicing campaigns',
    contractsForWorkUrl: 'Contracts for work application - URL',
    surveyEmailMessagePl: 'Default email message content for survey (PL)',
    surveyEmailMessageEng: 'Default email message content for survey (ENG)',
    mediaplannerApiProjectsByTeamsForCompanies:
      'Mediaplanner API projects by teams - allowed for companies',
    mirrorProject: 'Re-invoicing campaigns',
    mirrorProjectProfileName: 'Re-invoicing campaigns - trigger profile name',
    mirrorProjectCompanySysNumber:
      'Re-invoicing campaigns - target company system number',
    mirrorProjectTeamSysNumber: 'Re-invoicing campaigns - team system number',
  },
} as const;
